import { APIResponse } from '../models/api-response.model';
import { APIServiceService } from './apiservice.service';


export enum PaymentIntentType {
  BOOKING = 'booking'
}

export class PaymentsEndpoint {
  endpoint = 'payments/';
  constructor(private apiService: APIServiceService) {}



  createIntent(intentType: PaymentIntentType, hashedAppointmentId: string): Promise<APIResponse> {
    return new Promise((resolve, reject) => {

      this.apiService.doPOST(this.endpoint + '/intent', "", {intentType, hashedAppointmentId}).subscribe(response => resolve(response));
    });
  }





}
